import { render, staticRenderFns } from "./Add-Comment.vue?vue&type=template&id=0d7e0eee&scoped=true&"
import script from "./Add-Comment.vue?vue&type=script&lang=js&"
export * from "./Add-Comment.vue?vue&type=script&lang=js&"
import style0 from "./Add-Comment.vue?vue&type=style&index=0&id=0d7e0eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7e0eee",
  null
  
)

export default component.exports